import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { Icon, Button } from '@erecruit/ui-kit';
import { Authorize } from '@erecruit/modules';
import { AppPermissions } from '@erecruit/types';

const ProblemReport: FC = () => {
  const history = useHistory();

  return (
    <Authorize permission={AppPermissions.ReportProblem}>
      <Button
        style={{ padding: 0, height: '20px', width: '20px' }}
        type="tertiary"
        onClick={() => {
          history.push({
            pathname: '/problemreport',
            search: history.location.search,
            state: {
              modal: true,
            },
          });
        }}
      >
        <Icon type="feedback" />
      </Button>
    </Authorize>
  );
};

export default ProblemReport;
